import { ICol, IRow } from "../../../interfaces";
/**
 * Parses the columns of a row and transforms their structure.
 *
 * @param row - The row object containing columns and optional subrows to be parsed.
 * @returns An array of parsed columns. If the row contains subrows, it returns an array of arrays of parsed columns for each subrow.
 */
export const parseContentCols = (row: IRow) => {
  /**
   * Parses a single column, transforming its content if it contains nested columns.
   *
   * @param col - The column object to be parsed.
   * @returns The parsed column object with transformed content if applicable.
   */
  const parseCol = (col: ICol) => {
    if (col.content?.cols) {
      return {
        ...col,
        content: { cols: Object.values(col.content.cols) },
      };
    } else {
      return col;
    }
  };

  return row.subrows
    ? row.subrows.map((subrow: any) => {
        const cols: ICol[] = Object.values(subrow.cols);
        return cols.map(parseCol);
      })
    : Object.values(row.cols as Record<string, ICol>).map(parseCol);
};
